import styled from 'styled-components';
import { StyledCheckboxProps } from './Checkbox.types';
import { srOnly } from '../../../';

export const StyledCheckbox = styled.div<StyledCheckboxProps>`
  position: relative;
  display: block;

  ${srOnly}

  .checkbox__indicator {
    width: 24px;
    height: 24px;
    background-color: #f6f6f6;
    border: solid 1px #cacaca;
    border-radius: 4px;
    outline: dashed 2px transparent;
    outline-offset: 5px;
    color: #f6f6f6;
    transition: all 0.3s;
    cursor: pointer;

    @media (prefers-reduced-motion: reduce) {
      transition: none;
    }

    &:focus {
      outline: dashed 2px #000;
      &:not(:focus-visible) {
        outline: none;
      }
    }
  }

  .checkbox {
    pointer-events: none;
    &:checked {
      & + .checkbox__indicator {
        border: solid 1px #cacaca;
        background-color: #067bc1;
        color: white;
      }
    }
  }

  .checkbox__indicator-icon {
    position: relative;
    display: flex;
    justify-content: center;
    align-content: center;
    &:after {
      content: '';
      display: block;
      width: 15px;
      height: 14px;
      transform: rotate(42deg) translate3d(-1px, -2px, 0);
      border: solid 3px #fff;
      border-left: none;
      border-top: none;
    }
  }

  .checkbox__label-wrapper {
    display: flex;
    align-items: center;
    .checkbox__indicator {
      flex: 0 0 auto;
    }
    .checkbox__label {
      margin: 0 10px;
    }
  }

  .checkbox__label {
    cursor: pointer;
  }

  ${(props) => props.customStyle}
`;
